const firebaseStorage = require('../firebase').storage;

const uploadFile = async (file, targetPath, progressCB, errorCB, completedCB) => {
  const storageRef = firebaseStorage.ref(targetPath);

  const uploadTask = storageRef.put(file);
  uploadTask.on('state_change', (snapshot) => {
    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
    // const percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    // console.log('Upload is ' + percent + '% done');
    // switch (snapshot.state) {
    //   case 'paused':
    //     console.log('Upload is paused');
    //     break;
    //   case 'running':
    //     console.log('Upload is running');
    //     break;
    // }
    if (progressCB != null) {
      progressCB(0);
    }
  },
  (error) => {
    // A full list of error codes is available at
    // https://firebase.google.com/docs/storage/web/handle-errors
    // switch (error.code) {
    //   case 'storage/unauthorized':
    //     // User doesn't have permission to access the object
    //     break;
    //   case 'storage/canceled':
    //     // User canceled the upload
    //     break;

    //     // ...

    //   case 'storage/unknown':
    //     // Unknown error occurred, inspect error.serverResponse
    //     break;
    // }
    if (errorCB) {
      errorCB(error);
    }
  },
  () => {
    // Upload completed successfully, now we can get the download URL
    uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
      // Create file metadata to update
    //   const fileMetadata = {
    //     contentType: 'image/jpeg'
    //   };

      //   // Update metadata properties
      //   storageRef.updateMetadata(fileMetadata)
      //     .then((metadata) => {
      //       // Updated metadata for 'images/forest.jpg' is returned in the Promise
      //       console.log(metadata);
      //     }).catch((error) => {
      //       console.log('Uh-oh, an error occurred');
      //     });

      if (completedCB != null) {
        completedCB(downloadURL);
      }
    });
  });
};

module.exports = {
  uploadFile
};
